import { ProductsListFilters, ProductsListSortMode } from '@domains/products-catalog';

type MakeProductListQueryOptions = {
    searchQuery: string | null;
    sortMode?: ProductsListSortMode;
    page?: number;
    filters?: ProductsListFilters;
};

export const makeProductListQuery = (data: MakeProductListQueryOptions) => {
    const { searchQuery, sortMode, filters = {} } = data;
    const {
        is_novelty,
        is_ready_to_eat,
        is_promo,
        min_price,
        max_price,
        countries,
        manufacturers,
    } = filters;
    const query: Record<string, string | string[]> = {};

    if (searchQuery !== null) {
        query.search_query = searchQuery;

        if (sortMode !== ProductsListSortMode.Relevance && sortMode !== undefined) {
            query.sort_mode = sortMode;
        }
    } else if (sortMode !== ProductsListSortMode.Popularity && sortMode !== undefined) {
        query.sort_mode = sortMode;
    }

    if (is_novelty) {
        query.is_novelty = 'true';
    }

    if (is_ready_to_eat) {
        query.is_ready_to_eat = 'true';
    }

    if (is_promo) {
        query.is_promo = 'true';
    }

    if (min_price !== undefined) {
        query.min_price = min_price.toString();
    }

    if (max_price !== undefined) {
        query.max_price = max_price.toString();
    }

    if (countries !== undefined && countries.length > 0) {
        query.countries = countries;
    }

    if (manufacturers !== undefined && manufacturers.length > 0) {
        query.manufacturers = manufacturers;
    }

    return query;
};
